import { inject, ref } from 'vue-demi'
import { ACTIVE_PAGE, PROVIDE_KEYS } from './consts'

export const useActivePage = () => {
  return inject(PROVIDE_KEYS.ACTIVE_PAGE, ref(ACTIVE_PAGE.ENGINEER_DASHBOARD))
}
